import React, { Fragment } from 'react';
import { Table } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

export default function TestDetail({ type, setLoading, isOpenDetail, testDetails, handleIntroModalClose, t }) {
    return (
        <div>
            {/* Open test details */}
            <Modal
                show={isOpenDetail}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName={"test-details"}
            >

                <Modal.Body style={{ textAlign: 'center', padding: window.innerWidth > 767 ? '22px 60px' : "22px 35px", }}>
                    <img src='/images/student.svg' alt='' />
                    <h1 className="text-center">{t('Test Details')}</h1>
                    <p>{testDetails?.title}</p>
                    <div className="sticky-close" onClick={handleIntroModalClose}>
                        <img
                            src="/images/close.svg" width='15px' alt='' />
                    </div>


                    {type === 'history' ?
                        <div className='version-details text-left'>
                            <ol>
                                <li>{testDetails?.questions} multiple choice questions.</li>
                                <li>Each question has between 2 and 8 options out of which 1 or more may be correct.</li>
                            </ol>
                        </div> :
                        <div className='version-details text-left'>
                            <ol><li>Proctored online test.</li>
                                <li>{testDetails?.questions} multiple choice questions.</li>
                                <li>{Math.round(testDetails?.time / 60)} minutes.</li>
                                <li>Each question has between 2 and 8 options out of which 1 or more may be correct.</li>
                            </ol>
                        </div>}
                    {setLoading ?
                        '' :
                        testDetails && testDetails?.data?.length ?
                            <Fragment>
                                <h1 className="text-center mt-4">{t('Test History')}</h1>
                                <div className='mt-2'>
                                    <Table responsive >
                                        <thead>
                                            <th>Score</th>
                                            <th>Date</th>
                                        </thead>
                                        <tbody>
                                            {
                                                testDetails && testDetails?.data?.slice(0, 5)?.map(el => {
                                                    return (
                                                        <tr>
                                                            <td>{el.score}</td>
                                                            <td>{el?.createdAt?.split('T')[0]}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                            </Fragment>

                            :
                            null
                    }





                </Modal.Body>
            </Modal>
        </div >
    )
}
